import React from "react";

/**
 * Wide modal body matching Order Activity layout (illustration + content).
 */
const CourierActivityModal = ({
  title,
  subtitle,
  onClose,
  children,
  illustrationAlt = "Courier"
}) => (
  <div className="lightbox courier-detail-lightbox">
    <div className="activity-lightbox">
      <a
        href=""
        className="lightbox-close icon-clear"
        onClick={e => {
          e.preventDefault();
          onClose();
        }}
      />
      <div className="activity-left">
        <div className="lft-holder">
          <img
            src={require("../../../assets/images/img3.svg")}
            alt={illustrationAlt}
          />
          <span className="title">{title}</span>
        </div>
      </div>
      <div className="activity-right">
        {subtitle && <span className="title">{subtitle}</span>}
        {children}
      </div>
    </div>
  </div>
);

export default CourierActivityModal;
